export enum AdminPermissionType {
  MANAGE_TEMPLATES = 'MANAGE_TEMPLATES',
  DELETE_LOCKED_DOCUMENTS = 'DELETE_LOCKED_DOCUMENTS',
  VIEW_BI_ANALYTICS = 'VIEW_BI_ANALYTICS',
  VERIFY_AML_CHECKS = 'VERIFY_AML_CHECKS',
  MERGE_USERS = 'MERGE_USERS',
  MANAGE_COMMISSION_PROFILES = 'MANAGE_COMMISSION_PROFILES',
  MANAGE_ADMIN_USERS = 'MANAGE_ADMIN_USERS',
  MANAGE_HYPERLINKS = 'MANAGE_HYPERLINKS',
  MANAGE_EMAIL_SETTINGS = 'MANAGE_EMAIL_SETTINGS',
  MANAGE_SCHEDULED_JOBS = 'MANAGE_SCHEDULED_JOBS',
}
